import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import { KeyboardPlugin } from '../../../../../capacitor_plugins/keyboard';

// Actions
import { deselectAllElements, finishEditingElement } from '../../../../element/selection/selectionActions';

// Components
import Button from '../../../../components/buttons/Button';

// Selectors
import {
    getCurrentlyEditingEditorKey,
    getCurrentlyEditingId,
} from '../../../../element/selection/currentlyEditingSelector';

// Types
import { ToolbarListType } from '../../../../workspace/toolbar/toolbarTypes';

// Constants
import {
    DOCUMENT_MODAL_EDITOR_KEY,
    DOCUMENT_MODAL_TITLE_EDITOR_KEY,
} from '../../../../element/document/modal/documentModalConstants';

// Styles
import './MobileToolbarDoneButton.scss';

const MobileToolbarDoneButton = ({
    className,
    onClick,
    setDefaultToolbarType,
}: {
    className?: string;
    onClick?: () => void;
    setDefaultToolbarType: (toolbarType: ToolbarListType) => void;
}) => {
    const dispatch = useDispatch();

    const currentlyEditingEditorKey = useSelector(getCurrentlyEditingEditorKey);
    const currentlyEditingElementId = useSelector(getCurrentlyEditingId);

    const handleClick = () => {
        onClick?.();
        setDefaultToolbarType(ToolbarListType.MOBILE_TABS);
        if (Capacitor.isPluginAvailable('Keyboard')) {
            // We're manually calling the keyboard dismiss logic as any
            // manually 'shown' keyboards will not be dismissed automatically
            // when selection/focus is removed
            KeyboardPlugin.hide();
        }

        // dont deselect if we are editing the document editor to avoid multiple
        // people editing the same document at the same time
        if (
            currentlyEditingEditorKey === DOCUMENT_MODAL_EDITOR_KEY ||
            currentlyEditingEditorKey === DOCUMENT_MODAL_TITLE_EDITOR_KEY
        )
            return dispatch(finishEditingElement(currentlyEditingElementId));

        return dispatch(deselectAllElements());
    };

    return (
        <Button className={classNames('MobileToolbarDoneButton', className)} onClick={handleClick}>
            Done
        </Button>
    );
};

export default MobileToolbarDoneButton;
